// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.table-container {
  /* max-height: calc(100vh - 365px); */
  overflow: auto;
}

table {
  overflow: auto;
  border-collapse: collapse;
  width: 100%;
}

.table-spec {
  width: 100%;
  max-width: 100%;
  empty-cells: show;
  border: 0;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  font-weight: normal;
}

td {
  padding: 6px 10px;
}

th {
  border-top: none;
  position: sticky;
  top: 0;
  padding: 10px;
  background: #212529;
  color: #ffffff;
  font-size: 14px;
  z-index: 1;
}

tbody tr:nth-child(even) {
  background-color: #f2f2f2;
}

td .txtarea {
  width: 100% !important;
}

td textarea:hover {
  border: 1px solid gray !important;
}

.first td:nth-child(1) {
  color: teal;
}

.addEquipInput{
  width: 235px;
  border:  1px solid rgb(211, 211, 211);
  border-radius: 5px;
}


.inactiveTab {
  background-color:#dddddd;
  color: gray;
}

.activeTab {
  background-color:#ffffff;
  box-shadow: 0px 0px 10px 0px rgba(97, 96, 97, 0.5);
}

.radio-container {
  transform: scale(0.85);
}

.custom-checkbox .custom-control-input1:checked ~ .custom-control-label::before {
  background-color: teal!important;
  border-color: teal;
}
.custom-checkbox .custom-control-input1:checked:focus ~ .custom-control-label::before {    
  box-shadow: none;   
  border-color: teal;
}
.custom-checkbox .custom-control-input1:focus ~ .custom-control-label::before {
  box-shadow: none;  
  border-color: teal;  
}

.alignIt
{
  margin-right: 5px;
  /* float: right; */
  /* padding-bottom: 1px; */
}

.disabled {
  cursor: not-allowed;
}


.app-toolbar{
  border:1px solid grey;
  position: sticky;
  position: -webkit-sticky; 
  top: 0;
  z-index: 1000;
}

.labelStyle{
  font-family: ProximaNova-Regular, TeXGyreHerosRegular, Helvetica, Arial, sans-serif; 
  font-size: 14px;
}

span[aria-label-action]:hover:after {
  content: attr(aria-label-action);
  padding: 4px 8px;
  position: absolute;
  right: 30px;
  top: -10px;
  white-space: nowrap;
  z-index: 999999;
  background:teal;
  color: white;
  border-radius: 5px;
  font-size: 16px;
}

.tableColumnFilter {
  background-color: white;
  border-radius: 4px;
  width: 100%;
  height: 31px;
  color:black;
  padding-left: 15px;
  border: 2px hidden black;
}

.show-hide {
  display: flex;
  justify-content: flex-end;
}

.d-inline-block {
  padding: 0 18px;
  height: 35px;
}

.inactiveTab {
  background-color:#dddddd;
  color: gray;
}

.activeTab {
  background-color:#ffffff;
  box-shadow: 0px 0px 10px 0px rgba(97, 96, 97, 0.5);
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/View/core/customer-aacount-access/customer-aacount-access.component.css"],"names":[],"mappings":";AACA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;AACpB;;;AAGA;EACE,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;EACxB,MAAM;EACN,aAAa;AACf;;AAEA;EACE,mFAAmF;EACnF,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,kDAAkD;AACpD;AACA,gsLAAgsL","sourcesContent":["\r\n.table-container {\r\n  /* max-height: calc(100vh - 365px); */\r\n  overflow: auto;\r\n}\r\n\r\ntable {\r\n  overflow: auto;\r\n  border-collapse: collapse;\r\n  width: 100%;\r\n}\r\n\r\n.table-spec {\r\n  width: 100%;\r\n  max-width: 100%;\r\n  empty-cells: show;\r\n  border: 0;\r\n}\r\n\r\ntd, th {\r\n  border: 1px solid #dddddd;\r\n  text-align: left;\r\n  font-weight: normal;\r\n}\r\n\r\ntd {\r\n  padding: 6px 10px;\r\n}\r\n\r\nth {\r\n  border-top: none;\r\n  position: sticky;\r\n  top: 0;\r\n  padding: 10px;\r\n  background: #212529;\r\n  color: #ffffff;\r\n  font-size: 14px;\r\n  z-index: 1;\r\n}\r\n\r\ntbody tr:nth-child(even) {\r\n  background-color: #f2f2f2;\r\n}\r\n\r\ntd .txtarea {\r\n  width: 100% !important;\r\n}\r\n\r\ntd textarea:hover {\r\n  border: 1px solid gray !important;\r\n}\r\n\r\n.first td:nth-child(1) {\r\n  color: teal;\r\n}\r\n\r\n.addEquipInput{\r\n  width: 235px;\r\n  border:  1px solid rgb(211, 211, 211);\r\n  border-radius: 5px;\r\n}\r\n\r\n\r\n.inactiveTab {\r\n  background-color:#dddddd;\r\n  color: gray;\r\n}\r\n\r\n.activeTab {\r\n  background-color:#ffffff;\r\n  box-shadow: 0px 0px 10px 0px rgba(97, 96, 97, 0.5);\r\n}\r\n\r\n.radio-container {\r\n  transform: scale(0.85);\r\n}\r\n\r\n.custom-checkbox .custom-control-input1:checked ~ .custom-control-label::before {\r\n  background-color: teal!important;\r\n  border-color: teal;\r\n}\r\n.custom-checkbox .custom-control-input1:checked:focus ~ .custom-control-label::before {    \r\n  box-shadow: none;   \r\n  border-color: teal;\r\n}\r\n.custom-checkbox .custom-control-input1:focus ~ .custom-control-label::before {\r\n  box-shadow: none;  \r\n  border-color: teal;  \r\n}\r\n\r\n.alignIt\r\n{\r\n  margin-right: 5px;\r\n  /* float: right; */\r\n  /* padding-bottom: 1px; */\r\n}\r\n\r\n.disabled {\r\n  cursor: not-allowed;\r\n}\r\n\r\n\r\n.app-toolbar{\r\n  border:1px solid grey;\r\n  position: sticky;\r\n  position: -webkit-sticky; \r\n  top: 0;\r\n  z-index: 1000;\r\n}\r\n\r\n.labelStyle{\r\n  font-family: ProximaNova-Regular, TeXGyreHerosRegular, Helvetica, Arial, sans-serif; \r\n  font-size: 14px;\r\n}\r\n\r\nspan[aria-label-action]:hover:after {\r\n  content: attr(aria-label-action);\r\n  padding: 4px 8px;\r\n  position: absolute;\r\n  right: 30px;\r\n  top: -10px;\r\n  white-space: nowrap;\r\n  z-index: 999999;\r\n  background:teal;\r\n  color: white;\r\n  border-radius: 5px;\r\n  font-size: 16px;\r\n}\r\n\r\n.tableColumnFilter {\r\n  background-color: white;\r\n  border-radius: 4px;\r\n  width: 100%;\r\n  height: 31px;\r\n  color:black;\r\n  padding-left: 15px;\r\n  border: 2px hidden black;\r\n}\r\n\r\n.show-hide {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.d-inline-block {\r\n  padding: 0 18px;\r\n  height: 35px;\r\n}\r\n\r\n.inactiveTab {\r\n  background-color:#dddddd;\r\n  color: gray;\r\n}\r\n\r\n.activeTab {\r\n  background-color:#ffffff;\r\n  box-shadow: 0px 0px 10px 0px rgba(97, 96, 97, 0.5);\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
